export default "__VITE_ASSET__2877b592__"